import type { CreditActiveAllocation, CreditActiveAllocationType } from '@frontend/api-types';
import { sortBy } from '@frontend/duck-tape';
import { getCurrentSubscriptionId } from './getCurrentSubscriptionId';

export type CreditBreakdownType =
  | CreditActiveAllocationType
  | 'FREE_INITIAL_CREDITS'
  | 'FREE_SIGNUP_CREDITS'
  | 'ROLLOVER';

export type CreditBreakdownItem = {
  allocationId: string;
  amount: number;
  creditType: CreditBreakdownType;
  expiration: string;
  remainingCredits: number;
};

export const getCreditBreakdown = (allocations: CreditActiveAllocation[]): CreditBreakdownItem[] => {
  const activeAllocations = allocations.filter((allocation) => {
    const remaining = allocation.amount - allocation.amountUsed;
    return remaining > 0;
  });
  const currentSubscriptionId = getCurrentSubscriptionId(allocations);

  const items = activeAllocations.map((allocation) => {
    const remaining = allocation.amount - allocation.amountUsed;
    const isRollover = allocation.creditType === 'SUBSCRIPTION' && allocation.id !== currentSubscriptionId;
    const creditType = isRollover ? ('ROLLOVER' as const) : allocation.creditType;

    return {
      allocationId: allocation.id,
      amount: allocation.amount,
      creditType,
      expiration: allocation.expiration,
      remainingCredits: remaining,
    };
  });

  return sortBy(items, (item) => new Date(item.expiration).getTime());
};
